<template>
    <Table :headers="headers" :items="paginatedData">
        <template #item-cell.id="{ item, label, header, index }">
            {{ (pagination.currentPage - 1) * pagination.perPage + index }}
        </template>

        <template #item-cell.action="{ item, label, header, index }">
            <w-form @submit.prevent="addNoHm(item)">
                <w-button class="my1 mr0" type="submit">
                    <w-icon> fal fa-file </w-icon>
                </w-button>
            </w-form>
        </template>
    </Table>
    <TablePagination
        :lastPage="getLastPage"
        :currentPage="pagination.currentPage"
        :perPage="pagination.perPage"
        @onClick="onPaginationChange($event)"
    />
</template>

<script>
import Hakmilik from "../Component/Hakmilik";
import Card from "../Component/Card";
import { Inertia } from "@inertiajs/inertia";
import Table from "./Table";
import TablePagination from "./TablePagination";
import { ref, defineComponent, computed } from "vue";

export default defineComponent({
    props: {
        cukais: [Object, Array],
    },
    components: {
        Hakmilik,
        Card,
        Table,
        TablePagination,
    },
    methods: {
        addNoHm(w) {
            const url = `butiran-cukai?no_hm=${w.no_hm}`;
            //  this.$inertia.get(url, {replace: true});
            window.open(url, "_blank");
        },
    },
    setup(props) {
        const headers = [
            { label: "Bil", key: "id" },
            { label: "Nama", key: "nama" },
            { label: "No. ID", key: "no_kp" },
            { label: "No. Hak Milik", key: "no_hm" },
            { label: "No. Akaun", key: "no_akaun" },
            { label: "No. Lot", key: "no_lot" },
            { label: "Amaun Cukai", key: "cukai" },
            { label: "Tindakan", key: "action" },
        ];

        const pagination = ref({
            perPage: 10,
            currentPage: 1,
            lastPage: 1,
        });

        const paginatedData = computed(() => {
            const { perPage, currentPage, lastPage } = pagination.value;
            return props.cukais.slice(
                (currentPage - 1) * perPage,
                perPage * currentPage
            );
        });

        const getLastPage = computed(() => {
            return props.cukais.length > 0
                ? Math.ceil(props.cukais.length / pagination.value.perPage)
                : 1;
        });

        function onPaginationChange(e) {
            pagination.value = e.value;
        }

        return {
            headers,
            pagination,
            paginatedData,
            getLastPage,
            onPaginationChange,
        };
    },
});
</script>
